import { sendPost } from "src/utils/sendApi";

export const sendUserQuerySlackMessage = sendPost(`v1/data/send_slack_message`)
